import { render, staticRenderFns } from "./EnergyFlow.vue?vue&type=template&id=be7537c8"
import script from "./EnergyFlow.vue?vue&type=script&lang=js"
export * from "./EnergyFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports